import { DROPDOWN_OVERLAY_PT } from '@/components/common/ChoiceCellEditor';
import { MOTION } from '@/components/common/motion';

/**
 * The PrimeReact `Dropdown` passthrough for the two selects in the projects toolbar.
 *
 * PrimeReact's `Dropdown` arrives wearing the bootstrap theme — a taller box, a different border
 * radius and the old blue focus ring — which is exactly the drift `ActionButton` was introduced to
 * end for buttons. This is the same move for the one control the app does not own the markup of:
 * the trigger is restyled to the 32 px, `rounded-lg`, gray-bordered box every other toolbar
 * control is.
 *
 * The panel and the option list come from the shared `DROPDOWN_OVERLAY_PT`, so this and the
 * in-cell `ChoiceCellEditor` drop the same overlay; only the trigger differs, because that one
 * has to fit inside a table cell. Every utility carries Tailwind's trailing `!`: the theme
 * stylesheet is imported after ours and is unlayered, so an equal-specificity rule loses on
 * source order — which is how the option text was still painting the bootstrap grey.
 */
export const TOOLBAR_DROPDOWN_PT = {
  root: {
    className: `flex h-8! items-center rounded-lg! border! border-gray-200! bg-white! px-3! shadow-none! hover:border-gray-300! [&.p-focus]:border-gray-300! [&.p-focus]:shadow-none! ${MOTION}`,
  },
  input: { className: 'flex-1! truncate! p-0! text-left! text-sm! text-gray-700! shadow-none!' },
  trigger: { className: 'ml-2! flex w-auto! shrink-0 items-center text-gray-400!' },
  ...DROPDOWN_OVERLAY_PT,
};

/** The label that names a toolbar control. Never wraps — a two-line "Sort by:" broke the row. */
export const TOOLBAR_LABEL_CLASSES = 'whitespace-nowrap text-sm text-gray-500';
